import { ComponentProps, FC } from 'react'
import { Popover } from '@systemeio/components'
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful'
import { twMerge } from 'tailwind-merge'

type ColorPickerProps = ComponentProps<typeof HexAlphaColorPicker>

const ColorPicker: FC<ColorPickerProps> = ({ color, className, ...rest }) => {
  return (
    <Popover.Root>
      <Popover.Trigger
        data-color-picker
        className="relative flex size-full max-w-fit cursor-pointer items-center truncate"
      >
        <div
          style={{ backgroundColor: color }}
          className={twMerge('size-10 rounded-full border border-text-secondary/90', className)}
        />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Positioner side="top" sideOffset={16}>
          <Popover.Popup>
            <div className="flex w-50 flex-col gap-3">
              <HexAlphaColorPicker color={color} {...rest} />
              <div className="flex">
                <div className="rounded-l-lg bg-bg-primary p-2">#</div>
                <HexColorInput
                  className="w-full rounded-r-lg border border-border-100/30 p-2 outline-hidden main-transition-colors focus:border-border-accent"
                  color={color}
                  onChange={rest.onChange}
                />
              </div>
            </div>
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  )
}

export default ColorPicker
